module.exports = __webpack_public_path__ + "img/in_banner3.6fc07fa1.png";